import { Box, BoxProps, ColorOptions, Icon, MaterialTextInput, RadioButton, Spacer, Text, TextProps } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, useCallback, useEffect, useState } from 'react'
import * as Yup from 'yup'
import { PaySecurelyButton } from '../../comps/PaySecurelyButton'
import { UPIType } from '../../data/models/UPI'
import { useLazyApiData, useStores } from '../../data/store'
import { convertHexToRGBA } from '../../utils'
import { pages, PAYMENT_MODE_SUBTYPES } from '../../utils/constants'
import { staticStrings } from '../../utils/string'
import { UPI } from '../../utils/validations'
//Commented UPI note
// const Dot = (
//   <>
//     <Text fontWeight="BLACK" fontSize="MEDIUM" textAlign="center" fontFamily="jiotype-bold">
//       &#8226;
//     </Text>
//     <Spacer direction="horizontal" size="SMALL" />
//   </>
// )

const popularVpa: any = ['@jio', '@ybl', '@paytm', '@okaxis', '@okhdfcbank', '@okicici', '@oksbi', '@upi']

const allVpa: any = [
  '@abfspay',
  '@andb',
  '@apl',
  '@axis',
  '@axisb',
  '@axisbank',
  '@axisgo',
  '@axl',
  '@barodampay',
  '@barodapay',
  '@boi',
  '@cbin',
  '@cboi',
  '@centralbank',
  '@cnrb',
  '@eazypay',
  '@ezeepay',
  '@fbl',
  '@hdfcbank',
  '@hdfcbankjd',
  '@hsbc',
  '@ibl',
  '@icici',
  '@idbi',
  '@idbibank',
  '@idfcbank',
  '@ikwik',
  '@imobile',
  '@jio',
  '@jkb',
  '@karurvysyabank',
  '@kaypay',
  '@kmb',
  '@kmbl',
  '@kotak',
  '@kvb',
  '@kvbank',
  '@lime',
  '@mahb',
  '@myicici',
  '@obc',
  '@okaxis',
  '@okhdfcbank',
  '@okicici',
  '@oksbi',
  '@paytm',
  '@payzapp',
  '@pingpay',
  '@pnb',
  '@pockets',
  '@rajgovhdfcbank',
  '@rmhdfcbank',
  '@sbi',
  '@ubi',
  '@uboi',
  '@unionbank',
  '@unionbankofindia',
  '@united',
  '@utbi',
  '@upi',
  '@waaxis',
  '@wahdfcbank',
  '@wasbi',
  '@ybl',
  '@yesbank',
  '@yesbankltd',
]

const UpiInput: FC = () => {
  const [upiId, setUpiId] = useState('')
  const [validatedVpaId, setValidatedVpaId] = useState('')
  const [isOfferValidated, setIsOfferValidated] = useState(false)
  const navigation = useNavigation()
  const { navigate } = useNavigation()

  const {
    validateVpa,
    confirmPayment,
    amount,
    timeStamp,
    returnUrl,
    theme,
    intentid,
    vpa,
    mcc,
    validateOffer,
    applyOffer,
    offerApplied,
    updateIsOfferApplied,
    addPaymentMethod,
    isSubscriptionEnabled,
    isSubscriptionAllowedVPA,
  } = useStores((root) => ({
    amount: root.transaction.amount.payableAmount,
    timeStamp: root.transaction.timestamp,
    returnUrl: root.transaction.getMerchantRedirectingUrl(),
    confirmPayment: root.confirmPaymentApi,
    addPaymentMethod: root.transaction.addPaymentMethod,
    intentid: root.transaction.id.intentId,
    theme: root?.config?.merchantTheme,
    vpa: root?.merchant?.vpa,
    mcc: root?.merchant?.mcc,
    validateVpa: root.upiValidateVpaApi,
    validateOffer: root.offerValidateApi,
    applyOffer: root.offerTxnApplyApi,
    offerApplied: root.isOfferApplied,
    updateIsOfferApplied: root.transaction.updateIsOfferApplied,
    isSubscriptionAllowedVPA: root.isSubscriptionAllowedVPA,
    isSubscriptionEnabled: root.merchant.subscription.isEnabled,
  }))

  const [radioState, setRadioState] = useState(false)
  const [VPAError, setVPAError] = useState('')
  const [isValid, setIsValid] = useState(false)
  const [isUPIIntentValid, setIsUPIIntentValid] = useState(false)
  const [vpaTouched, setVpaTouched] = useState(false)
  const [lazyValidateVpaApi, { state: validateVpaState }] = useLazyApiData(validateVpa)
  const [confirmPaymentApi, { state: confirmPaymentState, data: confirmPaymentData }] = useLazyApiData(confirmPayment)

  const [validateOfferApi, { state: validateOfferState }] = useLazyApiData(validateOffer)
  const [lazyApplyOffer, { state: applyOfferState, data: applyOfferData }] = useLazyApiData(applyOffer)

  const isOfferApplied = offerApplied(PAYMENT_MODE_SUBTYPES.UPI)

  const styles = upiStyles(theme)

  const confirmUPIPayment = useCallback(() => {
    if (isSubscriptionEnabled && isSubscriptionAllowedVPA(upiId)) {
      navigation.navigate(pages.review, {
        paymentMode: 'UPI',
        paymentModeTitle: 'UPI',
      })
    } else {
      //call confirm api
      confirmPaymentApi()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigation])

  // TODO: Same as PaymentStatus, please refeactor
  useEffect(() => {
    if (validateVpaState === 'fulfilled') {
      if (upiId !== validatedVpaId) {
        if (isOfferApplied && validateOfferState !== 'rejected') {
          validateOfferApi({ vpa: upiId }, { type: 110, subType: 566 })
        } else {
          updateIsOfferApplied(false)
          confirmUPIPayment()
        }
      } else if (isOfferApplied && validateOfferState !== 'rejected') {
        validateOfferApi({ vpa: upiId }, { type: 110, subType: 566 })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateVpaState])

  useEffect(() => {
    if (validateOfferState === 'fulfilled') {
      if (upiId !== validatedVpaId) {
        lazyApplyOffer()
      }
      setIsOfferValidated(true)
      setVPAError(staticStrings.offerApplied)
    } else if (validateOfferState === 'rejected') {
      setVPAError(staticStrings.offerErrorUpi)
      setIsOfferValidated(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyApplyOffer, validateOfferState])

  useEffect(() => {
    if (applyOfferState === 'fulfilled') {
      confirmUPIPayment()
    } else if (applyOfferState === 'rejected') {
      setVPAError(applyOfferData?.failureMessage ?? 'Invalid offer')
    }
  }, [applyOfferData, applyOfferState, confirmUPIPayment, upiId])

  // TODO: Same as PaymentStatus, please refeactor
  useEffect(() => {
    if (confirmPaymentState === 'fulfilled') {
      // navigate(pages.progress)
      navigation.reset({
        index: 0,
        routes: [{ name: pages.progress }],
      })
    } else if (confirmPaymentState === 'rejected') {
      const response = confirmPaymentData
      navigate(pages.ErrorView, { title: 'Error occurred', error: response?.message, rUrl: returnUrl })
    }
  }, [confirmPaymentData, confirmPaymentState, navigate, navigation, returnUrl, timeStamp])
  const handleProceed = async () => {
    if (upiId === validatedVpaId && validateVpaState === 'fulfilled') {
      const upi = {
        id: 0,
        vpa: upiId,
        paymentType: 'UPI',
      } as UPIType
      addPaymentMethod(upi)
      if (isOfferApplied) {
        lazyApplyOffer()
      } else {
        updateIsOfferApplied(false)
        confirmUPIPayment()
      }
    } else {
      lazyValidateVpaApi(upiId)
    }
  }

  const validateUPIInput = (text: string, isSelected: boolean) => {
    let schema = Yup.object().shape({
      name: UPI,
    })
    schema
      .isValid({
        name: text,
      })
      .then((valid: any) => {
        if (valid) {
          setIsValid(true)
          setVPAError('')
          isSelected && validateVPAAPI(text)
        } else {
          setIsValid(false)
          setVPAError('Invalid VPA')
        }
      })
      .catch((err: any) => {
        setVPAError(err.errors)
      })
  }

  const BankNameItem = ({ item, onPress }: { item: any; onPress: any }) => {
    const handlePress = () => onPress(item)
    return (
      <Box {...styles.item} onPress={handlePress} underlayColor="GRAY_LIGHT">
        <>
          <Text {...styles.tagText}>{item?.toLowerCase()}</Text>
        </>
      </Box>
    )
  }

  const validateVPAAPI = (upiId: string) => {
    setValidatedVpaId(upiId)
    lazyValidateVpaApi(upiId)
  }
  //Commented UPI note
  //   <Box marginHorizontal={8}>
  //   <Text fontSize="MEDIUM">{staticStrings.simpleSteps}</Text>
  //   <Spacer size="SMALL" />
  //   <Box {...styles.stepBox}>
  //     {Dot}
  //     <Text>{staticStrings.vpa}</Text>
  //   </Box>
  //   <Spacer size="TINY" />
  //   <Box {...styles.stepBox}>
  //     {Dot}
  //     <Text>{staticStrings.upiins}</Text>
  //   </Box>
  //   <Spacer size="TINY" />
  //   <Box {...styles.stepBox}>
  //     {Dot}
  //     <Text>{staticStrings.psp}</Text>
  //   </Box>
  //   <Spacer size="TINY" />
  //   <Box {...styles.stepBox}>
  //     {Dot}
  //     <Text>{staticStrings.authorise}</Text>
  //   </Box>
  //   <Spacer size="SMALL" />
  // </Box>

  const searchFn = function (item: string) {
    const enteredVpaText = upiId.split('@')
    const search = enteredVpaText.length > 1 ? enteredVpaText[1].toLowerCase() : ''
    return item.substring(1).toLowerCase().startsWith(search)
  }

  const getTagData = () => {
    if (upiId.length > 3 && upiId.includes('@')) {
      const enteredVpaText = upiId.split('@')[1]
      const vpaList = enteredVpaText ? allVpa : popularVpa
      const bankNameList = vpaList.filter(searchFn)
      return bankNameList
    } else {
      return []
    }
  }

  const onRadioSelected = () => {
    console.log('onRadioSelected')
    setRadioState(!radioState)
    setIsUPIIntentValid(true)
  }

  const handleUPIIntent = () => {
    const url = `intent://pay?pa=${vpa}&mc=${mcc}&tr=${intentid}&am=${amount}&cu=INR#Intent;scheme=pij;S.browser_fallback_url=${encodeURIComponent(
      'javascript:handleNoPspApp()',
    )};end;`
    window.location.href = url
  }

  const isLoading =
    validateVpaState === 'pending' ||
    confirmPaymentState === 'pending' ||
    validateOfferState === 'pending' ||
    applyOfferState === 'pending'

  return (
    <>
      <Box {...styles.containerView}>
        <Box {...styles.textContainer}>
          <MaterialTextInput
            testID={'upiVpaTextInput'}
            label="UPI Handle"
            editable={true}
            value={upiId}
            touched={vpaTouched}
            errorColor={
              isOfferValidated && VPAError === staticStrings.offerApplied
                ? (theme.brandColor as ColorOptions)
                : undefined
            }
            error={VPAError}
            placeholderTextColor={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
            onFocus={() => {
              setVpaTouched(false)
            }}
            onBlur={() => {
              console.log('onBlur1 called')
              validateUPIInput(upiId, false)
              setTimeout(() => {
                setVpaTouched(true)
              }, 500)
            }}
            onChangeText={(text: string) => {
              validateUPIInput(text, false)
              setUpiId(text)
            }}
            color={theme?.bodyTextColor as ColorOptions}
            bottomLineColor={theme?.brandColor as ColorOptions}
            tintColor={theme?.brandColor as ColorOptions}
          />
        </Box>

        <>
          {getTagData().length > 0 && (
            <Box ph={8}>
              <Text
                value="Select your UPI Provider"
                fontFamily="jioType-medium"
                fontSize={12}
                color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
              />
              <Spacer direction="vertical" size={8} />
              <Box {...styles.tagsViewContainer}>
                {getTagData().map((item: any) => (
                  <BankNameItem
                    item={item}
                    onPress={() => {
                      const enteredVpaText = upiId.split('@')
                      const vpaText = enteredVpaText.length > 0 ? `${enteredVpaText[0]}${item}` : item
                      setUpiId(vpaText)
                      validateUPIInput(vpaText, true)
                    }}
                  />
                ))}
              </Box>
            </Box>
          )}
          {getTagData().length === 0 && (
            <Box padding={8} paddingTop={0} flexDirection="row" alignItems="center">
              <Icon id="INFO" color={theme?.brandColor as ColorOptions} size={16} />
              <Spacer direction="horizontal" size={8} />
              <Text {...styles.infoText} title="JioMoney, GooglePay, Phonepe, and more" />
            </Box>
          )}
        </>
        <Box {...styles.payBtnMobile}>
          <PaySecurelyButton
            disabled={!isValid}
            amount={amount}
            testID={'upiPaySecurelyBtn'}
            onPress={handleProceed}
            isLoading={isLoading}
          />
        </Box>

        <Box>
          <RadioButton color="PRIMARY" checked={radioState} textLabel="UPI Intent" onChange={onRadioSelected} />
        </Box>

        <Box {...styles.payBtnMobile}>
          <PaySecurelyButton
            disabled={!isUPIIntentValid}
            amount={amount}
            testID={'upiPaySecurelyBtn'}
            onPress={handleUPIIntent}
            isLoading={isLoading}
          />
        </Box>
      </Box>
    </>
  )
}

/* const shadow = {
  backgroundColor: '#2469FF',
  shadowColor: '#2469FF',
  shadowOffset: {
    width: 1,
    height: 2,
  },
  shadowOpacity: 0.1,
  shadowRadius: 1,
  elevation: 1,
} */
const upiStyles = (theme: any) => ({
  containerView: { flex: 1, width: '100%', padding: 16, backgroundColor: theme?.bodyBgColor } as BoxProps,
  textContainer: { marginHorizontal: 8, height: 50, marginBottom: 20 } as BoxProps,
  payBtn: { marginTop: 24, bottom: 0, alignSelf: 'flex-end', right: 0 } as BoxProps,
  payBtnMobile: { flex: 1, marginTop: 24, justifyContent: 'flex-end' } as BoxProps,
  errorText: {
    color: 'RED',
    textAlign: 'center',
    fontSize: 14,
  } as TextProps,
  infoText: {
    paddingVertical: 16,
    color: convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions,
    textAlign: 'left',
    fontSize: 12,
    fontFamily: 'jioType-medium',
  } as TextProps,
  ErrorView: {
    marginHorizontal: 16,
    width: '100%',
    right: 0,
    left: 0,
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    paddingVertical: 8,
  } as BoxProps,
  stepBox: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  } as BoxProps,
  tagsViewContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  } as BoxProps,
  item: {
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    paddingHorizontal: 8,
    paddingVertical: 6,
    marginRight: 0,
    margin: 4,
    borderRadius: 4,
    borderColor: theme?.brandColor as ColorOptions,
    borderWidth: 1,
    backgroundColor: convertHexToRGBA(theme?.brandColor, 10) as ColorOptions,
  } as unknown as BoxProps,
  tagText: {
    paddingVertical: 4,
    color: theme?.brandColor as ColorOptions,
    textAlign: 'left',
    fontSize: 12,
    fontFamily: 'jioType-medium',
  } as TextProps,
})

export default UpiInput
